function apiBase(): string {
  if (typeof window !== 'undefined' && process.env.NODE_ENV === 'development') {
    const { hostname, port } = window.location;
    if ((hostname === 'localhost' || hostname === '127.0.0.1') && port === '5000') {
      return '/api';
    }
  }
  return (process.env.REACT_APP_API_URL || 'http://localhost:5001/api').replace(/\/$/, '');
}

function authHeaders(): HeadersInit {
  const token = localStorage.getItem('token');
  return {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
}

export interface CustomerNotificationDto {
  _id: string;
  type: 'order' | 'payment' | 'shipping' | 'contact' | 'promo' | 'system';
  title: string;
  message: string;
  read: boolean;
  actionUrl?: string;
  createdAt: string;
  meta?: Record<string, unknown>;
}

export async function fetchCustomerNotifications(params?: { limit?: number; unread?: boolean }) {
  const q = new URLSearchParams();
  if (params?.limit) q.set('limit', String(params.limit));
  if (params?.unread) q.set('unread', '1');
  const res = await fetch(`${apiBase()}/customer-notifications?${q}`, { headers: authHeaders() });
  const json = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(json.message || 'Failed to load notifications');
  }
  return json as { success: boolean; data: CustomerNotificationDto[]; unreadCount: number };
}

export async function markCustomerNotificationRead(id: string) {
  const res = await fetch(`${apiBase()}/customer-notifications/${id}/read`, {
    method: 'PATCH',
    headers: authHeaders(),
  });
  const json = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(json.message || 'Failed to update notification');
  return json;
}

export async function markAllCustomerNotificationsRead() {
  const res = await fetch(`${apiBase()}/customer-notifications/read-all`, {
    method: 'PATCH',
    headers: authHeaders(),
  });
  const json = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(json.message || 'Failed to update notifications');
  return json;
}

export async function deleteCustomerNotification(id: string) {
  const res = await fetch(`${apiBase()}/customer-notifications/${id}`, {
    method: 'DELETE',
    headers: authHeaders(),
  });
  const json = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(json.message || 'Failed to delete notification');
  return json;
}
